import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const handleBack = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <>
      {!isHomePage && (
        <button onClick={handleBack} className="floating-home-btn" aria-label="Go Back" style={{ cursor: 'pointer' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          <span className="floating-home-label">Back</span>
        </button>
      )}

      <nav className="floating-navbar-wrapper" role="banner">
        <div className="floating-navbar">
          <div className="floating-nav-links">
            <Link to="/investment-calculators" className="floating-nav-link">
              Calculators
            </Link>
            <Link to="/talk-with-me" className="floating-nav-cta">
              Talk with me
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
}
